var id = 0;

function _class_private_field_loose_key(name) {
    return "__private_" + id++ + "_" + name;
}
export { _class_private_field_loose_key as _ };
